@use "../../../styles/variables.scss" as *;

.logoBar {
  border-bottom: 1px solid $light-beige;
  height: 3.5rem;
  display: flex;
  justify-content: center;
  padding: 0.5rem;

  .logo {
    width: 8.1rem;
  }
}
